export const API_ROUTES = {
  AGENT_KIPS_LIST: {
    METHOD: 'GET',
    URL: 'agency/agent-kpis-list',
  },
};
